<template>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title>
        <h2>Clients</h2>
        <v-spacer />
        <v-btn flat icon color="itoviGrayMid" @click="show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0 pl-3 pr-3">
        <div v-if="clients === null || clients.length === 0">
          No clients
        </div>
        <template>
          <v-data-table
              :headers="tableHeaders"
              :items="clients"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.first_name }}</td>
              <td class="text-xs-left">{{ props.item.last_name }}</td>
              <td class="text-xs-left">{{ props.item.email }}</td>
              <td class="text-xs-left">{{ props.item.phone }}</td>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .txt-bold {
    font-weight: bold;
  }
</style>

<script>
  export default {
    components: {
    },
    data: () => ({
      tableHeaders: [
        {
          text: 'First Name',
          align: 'left',
          sortable: true,
          value: 'first_name',
        },
        {
          text: 'Last Name',
          align: 'left',
          sortable: true,
          value: 'last_name',
        },
        {
          text: 'Email',
          align: 'left',
          sortable: true,
          value: 'email',
        },
        {
          text: 'Phone',
          align: 'left',
          sortable: false,
          value: 'phone',
        },
      ]
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      clients: {
        type: Array,
        required: true,
        default: () => ([])
      }
    },
    beforeCreate() {

    },
    watch: {},
    methods: {},
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
